<template>
  <div>
    <SubscriptionDetailModal
      :show="showSubscriptionModal"
      :toggle="toggleSubscriptionModal"
      :singleSubscriptionObj="singleSubscriptionObj"
      :refetch="refetch"
    />
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <SubscriptionFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('subscriptionRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchTransaction"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="subscriptionRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loading="setLoading(true)"
          @loaded="onLoaded"
          @row-click="handleClick"
        >
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
          <template slot="planName" slot-scope="{ row }">
            {{ titleCase(row.metadata.plan.name)  }}
          </template>
          <template slot="subscriptionType" slot-scope="{ row }">
            {{ titleCase(row.subscriptionType)  }}
          </template>
          <template slot="renewalDate" slot-scope="{ row }">
            {{ row.renewalDate | moment(" MM-DD-YYYY h:mm a") || 'N/A' }}
          </template>
          <template slot="name" slot-scope="{ row }">
           <span v-if="row.metadata.wallet"> {{ `${row.metadata.wallet.first_name} ${row.metadata.wallet.last_name}` }}</span><span v-else>N/A</span>
          </template>
          <template slot="walletRef" slot-scope="{ row }">
           <span v-if="row.option.walletRef"> {{ `${row.option.walletRef}` }}</span><span v-else>N/A</span>
          </template>
          <template slot="amount" slot-scope="{ row }">
            {{ toCurrency(row.amount) }}
          </template>
          <div slot="active" slot-scope="{ row }">
            <span
              class="badge badge-app"
              :class="row.active ? 'badge-success' : 'badge-danger'"
            >
              {{ row.active ? "Active" : "Inactive" }}
            </span>
          </div>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../../components/utils/TableWrapper/TableWrapper.vue";
import SubscriptionFilter from "../../../../../../components/filters/SubscriptionFilter.vue";
import SubscriptionDetailModal from "../../../../../../views/Customers/modals/SubscriptionDetailModal";

const tableHeadings = {
 "planName": "Plan",
  "name": "Name",
  subscriptionType: "Subscription Type",
  amount: "Amount",
  "walletRef": "Reference",
  createdAt: "Date Created",
  renewalDate: "Renewal Date",
  active: "Status",
};

export default {
  name: "Subscriptions",
  mixins: [componentData],
  data() {
    return {
      singleSubscriptionObj: null,
      showSubscriptionModal: false,
      emptyTitle: "No Suscription Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(tableHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    SubscriptionFilter,
    SubscriptionDetailModal,
  },
  methods: {
    toggleSubscriptionModal() {
      this.showSubscriptionModal = !this.showSubscriptionModal;
    },
    handleClick({ row }) {
      this.singleSubscriptionObj = row;
      this.showSubscriptionModal = true;
    },
    refetch(filters) {
      let newFilters = { ...filters };
      if (newFilters.status) newFilters.status = newFilters.status.value;
      this.handleRefetch(newFilters, this.fetchTransaction, "subscriptionRef");
    },
    async fetchTransaction() {
      this.options.requestFunction = async (data) => {
        const params = {
          ...data,
          ...this.filters,
          id: this.$route.params.clientid,
          customer: this.$route.params.customerid,
        };
        const response = await this.$store.dispatch(
          "payment/getCustomerSubscriptions",
          {
            params,
          }
        );

        const newData = response.data.customerSubscription.data;
        const count = response.data.customerSubscription.count;
        return { ...response, count, total: count, data: newData };
      };
    },
  },

  created() {
    this.fetchTransaction();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
